module.exports = __webpack_public_path__ + "img/paycomet.a85c37d1.png";